export const ACTIONS_OPENED = 'moreButton/ACTIONS_OPENED';

export const actionsOpened = payload => ({
  type: ACTIONS_OPENED,
  payload,
});



// WEBPACK FOOTER //
// ./app/actions/actions-opened.js